import domWrap from "../utils/domWrap";
import h from "../utils/htm";

export default async accordion => { // 'comp-accordion'
    var acc = domWrap(accordion).getElementsByClassName('accordion');
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;

            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
                this.children[0].style = null;
                this.style = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
                this.children[0].style = "transform: rotateZ(-180deg);";
                this.style.border = "0";                
                if (panel.children.length > 1) {
                    var img = panel.children[panel.children.length - 1].cloneNode();
                    var leftImg = this.parentElement.previousElementSibling;
                    if (leftImg) {
                        leftImg.replaceChild(img, leftImg.childNodes[0]);
                        fadeIn(img);
                    }
                }
            }

            //reset others
            var j;
            for (j = 0; j < acc.length; j++) {
                if (acc[j] != this) {
                    if (acc[j].classList.contains("active")) {
                        acc[j].classList.toggle("active");
                    }
                    acc[j].children[0].style = null;
                    acc[j].style = null;
                    acc[j].nextElementSibling.style.maxHeight = null;
                }
            }
        });
    }

    window.addEventListener('resize', function (event) {
        if (window.innerWidth < 1000) {
            $('.accordion.active').next().css('max-height', '100%');
        }
    }, true);

    //open first panel
    acc[0].click();
};


function fadeIn(el) {
    el.style.opacity = 0;
    var tick = function () {
        el.style.opacity = +el.style.opacity + 0.01;
        if (+el.style.opacity < 1) {
            (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16)
        }
    };
    tick();
}
